import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { ICellRendererParams } from 'ag-grid-enterprise';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { PipesModule } from '@shared/pipes/pipes.module';

export interface IAddressRendererParams extends ICellRendererParams {
  clickable: boolean;
  isAddressHidden: boolean;
}
@Component({
  selector: 'app-address-renderer',
  standalone: true,
  imports: [RouterModule, PipesModule],
  template: ` <section class="address-container flex flex-col gap-2">
    @if (params.isAddressHidden) {
      <span style="filter: blur(2px); letter-spacing: 2px;">HIDDEN PANEL</span>
    } @else {
      @if (params.clickable) {
        <a (click)="params.data.parent_id ? navigateToProject() : navigateToProperty()">{{
          params.value || params.data?.title || params.data.address_string
        }}</a>
      } @else {
        @if (params.value || params.data.address_string) {
          <span>{{ params.value || params.data.address_string }}</span>
        }
      }
      @if (!params.data.parent_id) {
        <span class="property-info text-sm text-hint">
          {{ params.data.property_type?.name }} •
          @if (params.data.apn) {
            {{ params.data.apn }} •
          }
          @if (params.data.year_built) {
            Built in {{ params.data.year_built }} •
          }
          @if (params.data.unit_size) {
            {{ params.data.unit_size }} Units •
          }
          @if (params.data.rentable_sq_ft && params.data.rentable_sq_ft > 0) {
            {{ params.data.rentable_sq_ft | formatNumber: 0 }} SF •
          }
          @if (params.data.parcel_size && params.data.parcel_size > 0) {
            {{ params.data.parcel_size | formatNumber: 2 }} Acres •
          }
          @if (params.data.last_sale_price && params.data.last_sale_price > 0) {
            Last Sale: {{ params.data.last_sale_price | tsCurrency: 'USD' : 'symbol' : '1.0' }}
            @if (params.data.last_sale_date) {
              on {{ params.data.last_sale_date | formatDate }}
            }
          }
        </span>
      } @else {
        <span class="portfolio-info text-sm text-hint">
          {{ params.data.property_type?.name }}
          @if (params.data.properties?.length > 0) {
            <span> • {{ params.data.address?.address_string }}</span>
          }
        </span>
      }
    }
  </section>`,
  styles: [
    `
      .address-container {
        padding: 15px 0;
        line-height: 1;

        & .portfolio-info {
          display: flex;
          gap: 2px;
        }
        & a {
          text-decoration: underline;
          cursor: pointer;
        }
      }
    `,
  ],
})
export class TableAddressRendererComponent implements ICellRendererAngularComp {
  public params: IAddressRendererParams;

  constructor(private router: Router) {}

  agInit(params: IAddressRendererParams): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }

  navigateToProperty() {
    this.router.navigate(['/properties', this.params.data.id]);
  }

  navigateToProject() {
    this.router.navigate(['/projects', this.params.data.pipeline_id, this.params.data.id, 'details', 'overview']);
  }
}
